import { MainLayout } from '@components/layouts/main.layout';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { Tile } from '@components/shared/tile.component';
import { useCurrentUserExpertProfile } from '@queries/expert-profile.query';
import { useGetCurrentUser } from '@queries/users.query';
import { useState } from 'react';
import { ExpertProfileDetails } from './components/expert-profile-details.component';
import { ExpertProfileModal } from './components/expert-profile-modal.component';

export const ExpertProfilePage: React.FC = () => {
  const { data: currentUser, isPending: isCurrentUserPending } = useGetCurrentUser();
  const { data: expertProfile, isPending: isExpertProfilePending } = useCurrentUserExpertProfile();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <PageviewTracker>
      <HelmetWrapper title="Expert Profile" />
      <MainLayout fullWidth>
        <div className="max-w-(--breakpoint-lg) mx-auto w-full flex flex-col gap-4">
          <Tile
            isLoading={isCurrentUserPending || isExpertProfilePending}
            isEmpty={!expertProfile || !currentUser}
            loadingState={{ message: 'Loading profile...' }}
            emptyState={{
              message: 'Create your Expert Profile now',
              title: 'Expert Profile Missing',
              onClick: () => setIsModalOpen(true),
            }}
            className="p-0"
          >
            {expertProfile && currentUser && (
              <ExpertProfileDetails
                user={currentUser}
                expertProfile={expertProfile}
                onEditProfile={() => setIsModalOpen(true)}
              />
            )}
          </Tile>
        </div>

        <ExpertProfileModal
          expertProfile={expertProfile}
          isEdit={!!expertProfile}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </MainLayout>
    </PageviewTracker>
  );
};
